import { format } from 'date-fns';

export const getDateWithTimeZone = (activityDate: string) => {
    const date = new Date(activityDate);

    const parts = new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
        .formatToParts(date);
    const tz = parts.find(p => p.type === 'timeZoneName')?.value ?? 'UTC';

    const time = format(date, 'h:mma');
    const day = format(date, 'MMMM d, yyyy');

    return `${time} ${tz} on ${day}`;
};
